import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ITrain } from 'src/app/storage/interfaces/train.interface';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

const URL = environment.aws.amplify.API.REST;

@Injectable({ providedIn: 'root' })
export class TrainsService {
  constructor(private translateService: TranslateService, private apiService: ApiService) { }

  async getMissionTrains(missionId: string): Promise<ITrain[] | null> {
    const translations = await this.translateService.get('MISSIONS').toPromise();
    const response = await this.apiService.get(
      `${URL}trains/mission/${missionId}`,
      translations['LABEL']
    );

    return response?.trains ?? null;
  }
}
